import React from "react";

import SBCLinkCell from "ComparePlans/Components/SBCLinkCell";
import { useUpdateUserExperienceFlagsMutation } from "EmployerApplication/api";
import isIntuit from "Intuit/isIntuit";
import { useSelector, useDispatch } from "react-redux";
import AnalyticsTracking from "Utils/AnalyticsTracking";

import { PlanHeader, FeatureBox, MonthlyCost } from "Cobalt/Plan/Card";
import BodyText from "Common/BodyText";
import Button from "Common/Button";
import { Card, CardSection } from "Common/Card/";
import { addPlanToCart } from "Common/CartService";
import { Col, Row } from "Common/Grid";
import { Div } from "Common/HTML";
import Icon from "Common/Icon";

import makeBem from "Utils/makeBem";

const bem = makeBem("LifePlanCard");

const LifePlanCard = ({ plan, onHide }) => {
  const { benefits, id: planID } = plan;
  const companyIDToken = useSelector((state) => state.companyProfile?.idToken);
  const [updateUserExperienceFlags] = useUpdateUserExperienceFlagsMutation();
  const dispatch = useDispatch();

  const addLifePlanHandler = (plan) => {
    AnalyticsTracking.trackEvent("cta_clicked", {
      label: "add_life_plan_to_cart",
      plan_id: planID,
    });

    updateUserExperienceFlags({
      companyIDToken,
      added_life_plan: true,
    });

    dispatch(addPlanToCart({ planType: "life", plan }));
    onHide();
  };

  return (
    <Card mx={4} p={0}>
      <CardSection className={bem("Summary")}>
        <PlanHeader plan={plan} />
        <FeatureBox plan={plan} title="Coverage" field="coverage_amount" format="currency" />
        <FeatureBox plan={plan} title="Policy Type" field="plan_type" />
        <FeatureBox plan={plan} title="Contribution" value="100%" />
        <Div className={bem("PlanCosts")}>
          <MonthlyCost cost={plan.average_monthly_premium} loading={false} hasFootnote={false} />
        </Div>
      </CardSection>
      <CardSection p={4}>
        <Row pt={4}>
          {benefits?.map((benefit, i) => (
            <Col sm={6} mb={2} key={i}>
              <Div style={{ display: "flex" }} mt={isIntuit() ? 1 : 2}>
                <BodyText className={bem("benefit")}>
                  <Icon icon="check" size="sm" mr={3} style={{ textAlign: "center" }} />

                  {benefit}
                </BodyText>
              </Div>
            </Col>
          ))}
        </Row>
        <Row pt={4}>
          <Col md={6}>
            <SBCLinkCell plan={plan} copy="Download Plan Document" />
          </Col>
          <Col md={6} style={{ textAlign: "right" }}>
            <Button
              size="medium"
              onClick={() => {
                addLifePlanHandler(plan);
              }}
            >
              Add Plan
            </Button>
          </Col>
        </Row>
      </CardSection>
    </Card>
  );
};

export default LifePlanCard;
